import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Actions as ACTIONS } from '../../store/actions/noteActions';
import { format, addMonths, lastDayOfMonth } from 'date-fns';

export const NoteRow = ({
  note,
  user,
  viewDetails,
}) => {

  // todo add icons to show if payroll note or reminder

  return (
    <tr>
      <td>{format(new Date(note.date),"do MMM yyyy HH:mm")}</td>
      <td>{note.note}</td>
      <td>
          <i
            onClick={() => viewDetails(note)}
            style={{cursor: 'pointer'}}
            className={`si si-eye`}
           />
      </td>
    </tr>
  );
};

const mapStateToProps = (state, ownProps) => {


  // find user who made log entry

  return {

  };
};

const mapDispatchToProps = (dispatch) => ({
  viewDetails: (item) =>
    dispatch(ACTIONS.showNoteDetail({show:true, item})),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoteRow);
